export default __webpack_public_path__ + "static/2101-0ee5f8c3c8a62581001ed5d467651c86.jpg";